import React, { useContext } from "react";
import { useDispatch } from "react-redux";

import { PopupContext } from "@app/dev/contexts/popup";

import { RegisterMode, ClearCardRegistered } from "../../../../dev/actions/terminal";

const FailPopup = ({ textCode }) => {
	const dispatch = useDispatch();
	const [{ closePopup }] = useContext(PopupContext);

	const registerPopupForDms = () => {
		closePopup();
		dispatch(RegisterMode(false));
		dispatch(ClearCardRegistered());
	};

	return (
		<div className="ticket-results-view-p">
			<h3>{t("Something went wrong")}!</h3>
			<h3>{t(textCode)}</h3>
			<h3>{t("Please try again")}</h3>
			<div className="buttons-view-w-t">
				<ul>
					<li>
						<div className="separator-box-buttons-m">
							<button
								className="button-view-normal-m trans-m"
								onClick={registerPopupForDms}
							>
								{t("Ok")}
							</button>
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default FailPopup;
